"use client"
import { type TrackableInterfaceEvent, track } from "@opensea/analytics"
import { useDisconnect as useWalletDisconnect } from "@opensea/wallet"

export function useDisconnect({ source }: { source: string }) {
  const { disconnect } = useWalletDisconnect()

  return async ({ event }: { event?: TrackableInterfaceEvent } = {}) => {
    await disconnect()

    void track("Wallet Disconnected", { source }, event)
  }
}
